import(/* webpackMode: "eager", webpackExports: ["TranslationProvider"] */ "/srv/site/app/i18n/TranslationContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/site/components/static/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/site/components/static/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleTagManager"] */ "/srv/site/node_modules/@wonderful/wwc/dist/src/modules/GoogleTagManager/GoogleTagManager.js");
;
import(/* webpackMode: "eager", webpackExports: ["MonotypePageViewTracker"] */ "/srv/site/node_modules/@wonderful/wwc/dist/src/modules/MonotypePageViewTracker/MonotypePageViewTracker.js");
;
import(/* webpackMode: "eager", webpackExports: ["OneTrust"] */ "/srv/site/node_modules/@wonderful/wwc/dist/src/modules/OneTrust/OneTrust.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/srv/site/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager" */ "/srv/site/styles/styles.scss");
